import { render, staticRenderFns } from "./registeredIncident.vue?vue&type=template&id=10bb17ce"
import script from "./registeredIncident.vue?vue&type=script&lang=js"
export * from "./registeredIncident.vue?vue&type=script&lang=js"
import style0 from "./registeredIncident.vue?vue&type=style&index=0&id=10bb17ce&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports